


export const NotSufficientRole = () => {
    return(
        <>
        <div className="font-bold text-xl mt-5 ml-5">
            Vous n'avez pas les droits nécessaires pour accèder à cette page.
        </div>
        </>
    )
}